import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: 16,
    margin: '12px 0'
  },
  header: {
    marginBottom: 16
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.grey[500],
    fontSize: 13,
    marginTop: 4
  },

  toggleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 0',
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    marginBottom: 16
  },

  toggleText: {
    display: 'flex',
    flexDirection: 'column'
  },

  statsRow: {
    display: 'flex',
    gap: 16
  },

  statBox: {
    flex: 1,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 8,
    padding: 16
  },
  statLabel: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: 8
  },
  statValue: {
    fontSize: 22,
    fontWeight: 600
  },
  skeleton: { width: 60 }
}))
export default useStyles
